import { cbLogoPath } from ':cloud/widgets/buildQuest/assets/cbLogo';
import { blueGradient } from ':cloud/widgets/buildQuest/assets/colors';
import { hexagonPath } from ':cloud/widgets/buildQuest/assets/hexagon';
import { CompletedTile } from ':cloud/widgets/buildQuest/CompletedTile';
import { SVG_PROPS, TILE_HEIGHT, TILE_WIDTH } from ':cloud/widgets/buildQuest/constants';

import { ReactComponent as CBLogo } from './assets/cbLogo.svg';

type CenterTileProps = {
  completed: boolean;
};
export function CenterTile({ completed }: CenterTileProps): React.ReactElement {
  if (!completed) {
    return (
      <svg {...SVG_PROPS}>
        <defs>
          <mask id="centerMask">
            <path d={hexagonPath} strokeWidth="3" stroke="#FFF" />
            <path d={cbLogoPath} fill="#FFF" />
          </mask>
        </defs>

        <foreignObject width={TILE_WIDTH} height={TILE_HEIGHT} mask="url(#centerMask)">
          <div className={blueGradient} style={{ height: `${TILE_HEIGHT}px` }} />
        </foreignObject>
      </svg>
    );
  }

  return <CompletedTile id="0" pointValue={10} variant="center" centerIcon={<CBLogo />} />;
}
